import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { ACTION_TYPES } from "../../../app/actionTypes";
import {
  setActionPayload,
  setActionType,
} from "../../../features/authorizationSlice";
import { resetRequest } from "../../../features/transactionDetailsSlice";

export default function ApproveRejectTransaction({
  transactionId,
  method,
  account,
  onOpenQrAfterGenerate,
}) {
  const dispatch = useDispatch();

  const handleApproveReject = useCallback(
    (status) => {
      dispatch(resetRequest());
      dispatch(setActionType(ACTION_TYPES.APPROVE_TRX));
      dispatch(
        setActionPayload({
          TransactionID: transactionId,
          Status: status,
          IsQuickPayAmendment: method === "Quick Pay",
          IsPendingBankTransfer: account === "BSL",
        }),
      );
      onOpenQrAfterGenerate?.();
    },
    [account, dispatch, method, onOpenQrAfterGenerate, transactionId],
  );

  return (
    <div className="new-approval-action-group new-pending-approvals-page__yes-no new-payroll-page__yes-no">
      <button
        type="button"
        className="new-approval-action-button is-approve new-pending-approvals-page__yes-action new-payroll-page__yes-action"
        onClick={(event) => {
          event.stopPropagation();
          handleApproveReject("Approve");
        }}
        aria-label={`Approve transaction ${transactionId}`}
      >
        <FontAwesomeIcon icon={faCheck} />
      </button>
      <button
        type="button"
        className="new-approval-action-button is-reject new-pending-approvals-page__no-action new-payroll-page__no-action"
        onClick={(event) => {
          event.stopPropagation();
          handleApproveReject("Reject");
        }}
        aria-label={`Reject transaction ${transactionId}`}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
}
